// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e6f73f7a","455":"db341e74","488":"ea67f7ff"}[chunkId] + ".chunk.js";
};